module.exports = __webpack_public_path__ + "img/sangfor.ca5667ef.png";